import { API_URL, Accept } from "../constants.js";
import { notify } from "react-notify-toast";
export default async function riderCashPayment(
  component,
  payload
  // job_order_id,
  // payment,
  // trans_id,
  // amount
) {
  console.log("componentcheck", component, payload);
  const Authorization = "bearer " + localStorage.getItem("token");
  const body = {
    orderData: payload,
  };
  const res = await fetch(`${API_URL}rest/V1/rider/payment`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept, Authorization },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      if (!response.ok) {
        notify.show("Network Failure", "error");
      }
      return response.json();
    })
    .then(function (data) {
      console.log("riderCashPayment", data);
      if (data && data[0] && data[0].status == "failure" && data[0].hasOwnProperty("delay_time")) {
        component.setState({
          paymentValidationError: data[0].message,
          delay_time: data[0].delay_time,
          showDelayReasonModal: true,
        })
        return;
      } 
      if (data && data[0] && data[0].data) {
        component.props.actionDeliverySuccessDetails(data[0].data);
        component.setState({
          cashcardstate: data[0].status,
          returnOrderItemstate: data[0],
        });

        // component.setState({
        //   returnOrderItemstate: data[0],
        // });
      }

      //  console.log("riderUpdstatus", data[0].data.status);
      //   component.setState({
      //     getupdatestatusJob: data[0].data.status,
      //     loader: false
      //   });
      //   component.props.updateStatusAction(data);
      //   if(data[0].status == "success")
      //   {
      //     window.location.reload();
      //     return data.json();
      //   }
      //   if (data[0] && data[0].data === "success") {
      //     component.props.actionProcessingJobs(data[0].data);
      //   } else {
      //     component.props.actionProcessingJobs("failure");
      //   }
    });

  return res;
}



// WEBPACK FOOTER //
// ./src/utility/api/riderCashPayment.js